import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { ModalPanel } from 'foundations-components/transitional/components/ModalPanel';
import { H2 } from 'foundations-components/transitional/components/H2';
import { usePlaylist } from '../../savedItems/savedItemsQueries';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { HasScope, useAccounts, useUsersForAccount } from '../../accounts';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { Field, Form, useForm } from 'react-final-form';
import { FinalFormField } from '../../../components/FinalForm';
import { Form as FoundationsForm } from 'foundations-components/transitional/components/Form';
import { useCallback, useMemo } from 'react';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { required } from '../../../utils/validation';
import { useCreatePlaylistAssignment, usePlaylistAssignments, useUpdatePlaylistAssignments } from '../playlistAssignmentsQueries';
import { Alert } from 'foundations-components/transitional/components/Alert';
import ErrorBoundary from '../../../components/Errors/ErrorBoundary';
import { fromDateToUiDateInputFormat, fromUiDateInputFormatToUnixTs } from '../../../utils/CanvasComponents';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { View } from 'foundations-components/transitional/components/View';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { HubSpotterAccountUsersSelect } from './HubSpotterAccountUsersSelect';
import { TeamsSelect } from './TeamsSelect';
import UsageTracker from '../../../utils/UsageTracker';
import { Text } from 'foundations-components/components/Text';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { DateInput } from 'foundations-components/transitional/components/DateInput';
import { Select } from 'foundations-components/transitional/components/Select';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { useSimplePlaylists } from 'academy-common-lib/features/hubspotPlaylists/hooks/useSimplePlaylists';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import PortalIdParser from 'PortalIdParser';
import { ALL_PLAYLISTS_PATH } from '../../myTeam/constants/routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PlaylistAssignedNotification = ({
  assigneeCount,
  assignmentType,
  playlistId
}) => {
  var _simplePlaylists$play;
  // needs to retrieve the hydrated model for the playlist name
  // will be removed after migration
  const {
    simplePlaylists
  } = useSimplePlaylists({
    playlistIds: [playlistId]
  });
  const playlistName = (simplePlaylists === null || simplePlaylists === void 0 || (_simplePlaylists$play = simplePlaylists[playlistId]) === null || _simplePlaylists$play === void 0 ? void 0 : _simplePlaylists$play.name) || '';
  return /*#__PURE__*/_jsxs(ButtonWrapper, {
    children: [assignmentType === 'teams' ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.savedItems.tooltips.assignmentsCreated.team",
      options: {
        count: assigneeCount,
        playlistName
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.savedItems.tooltips.assignmentsCreated.teamMember",
      options: {
        count: assigneeCount,
        playlistName
      }
    }), /*#__PURE__*/_jsx(RouterButton, {
      marginInlineStart: "400",
      size: "small",
      to: {
        pathname: ALL_PLAYLISTS_PATH,
        search: `playlists=${playlistId}`
      },
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.savedItems.tooltips.viewProgress"
      })
    })]
  });
};
const tomorrowDate = new Date();
tomorrowDate.setDate(new Date().getDate() + 1);
const AccountsTabs = ({
  myAccounts,
  allAccounts
}) => {
  const form = useForm();
  const formState = form.getState();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Field, {
      name: "accountsRadio",
      render: ({
        input
      }) => /*#__PURE__*/_jsxs(ToggleGroup, {
        name: "accountsRadio",
        paddingBlockStart: "300",
        children: [/*#__PURE__*/_jsx(RadioInput, Object.assign({}, input, {
          defaultChecked: true,
          inline: true,
          value: "myAccounts",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.myAccounts"
          })
        })), /*#__PURE__*/_jsxs(RadioInput, Object.assign({}, input, {
          inline: true,
          value: "allAccounts",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.allAccounts"
          }), /*#__PURE__*/_jsx(Tooltip, {
            placement: "bottom",
            title: I18n.text('learningCenter.playlists.allAccountsTooltip'),
            children: /*#__PURE__*/_jsx(View, {
              display: "inline-block",
              marginInlineStart: "100",
              children: /*#__PURE__*/_jsx(InfoIcon, {
                size: "100"
              })
            })
          })]
        }))]
      })
    }), formState.values.accountsRadio === 'allAccounts' ? allAccounts : formState.values.accountsRadio === 'myAccounts' ? myAccounts : null]
  });
};
const ServerError = () => {
  return /*#__PURE__*/_jsxs(Alert, {
    marginBlockEnd: "300",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyErrors.badRequest.somethingsGoneWrong"
    }),
    type: "danger",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyErrors.badRequest.refreshPage"
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyErrors.badRequest.keepsHappening"
    })]
  });
};
const AssigneeSelector = ({
  input,
  accountId,
  isEditing,
  selectedUsers
}) => {
  const form = useForm();
  const formState = form.getState();
  const handleAssignmentTypeChange = () => {
    form.change('assignees', []);
  };
  const hasAssignees = formState.values.assignees && formState.values.assignees.length > 0;
  const currentAssignmentType = formState.values.assignmentType;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Field, {
      name: "assignmentType",
      render: ({
        input: radioInput
      }) => /*#__PURE__*/_jsxs(ToggleGroup, {
        columnGap: "200",
        name: "assignmentType",
        paddingBlockEnd: "400",
        children: [/*#__PURE__*/_jsx(Tooltip, {
          disabled: isEditing || !hasAssignees || currentAssignmentType === 'teamMembers',
          placement: "top",
          title: I18n.text('learningCenter.playlists.teamMembersTooltip'),
          children: /*#__PURE__*/_jsx(RadioInput, Object.assign({}, radioInput, {
            defaultChecked: true,
            disabled: hasAssignees && currentAssignmentType !== 'teamMembers' || isEditing,
            inline: true,
            onChange: e => {
              radioInput.onChange(e);
              handleAssignmentTypeChange();
            },
            value: "teamMembers",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.playlists.assignTeamMembers"
            })
          }))
        }), /*#__PURE__*/_jsx(Tooltip, {
          disabled: isEditing || !hasAssignees || currentAssignmentType === 'teams',
          placement: "top",
          title: I18n.text('learningCenter.playlists.teamsTooltip'),
          children: /*#__PURE__*/_jsx(RadioInput, Object.assign({}, radioInput, {
            disabled: hasAssignees && currentAssignmentType !== 'teams' || isEditing,
            inline: true,
            onChange: e => {
              radioInput.onChange(e);
              handleAssignmentTypeChange();
            },
            value: "teams",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.playlists.assignTeams"
            })
          }))
        })]
      })
    }), formState.values.assignmentType === 'teamMembers' ? /*#__PURE__*/_jsx(HubSpotterAccountUsersSelect, Object.assign({}, input, {
      accountId: accountId,
      disabled: isEditing || !formState.values.assignmentType,
      selectedUsers: selectedUsers
    })) : /*#__PURE__*/_jsx(TeamsSelect, Object.assign({}, input, {
      accountId: accountId,
      disabled: isEditing || !formState.values.assignmentType
    }))]
  });
};
const HubSpotterPortalUserAssign = ({
  isMultiUserAccount,
  isEditing,
  accountId,
  accounts,
  selectedUsers
}) => {
  const form = useForm();
  const handleAccountChange = () => {
    form.change('assignees', []);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FinalFormField, {
      fieldProps: {
        name: 'account'
      },
      formControlProps: {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.assignAccount"
        }),
        marginBlockStart: '700'
      },
      hidden: !isMultiUserAccount,
      render: input => /*#__PURE__*/_jsx(TextInput, Object.assign({}, input, {
        disabled: accounts.length === 1 || isEditing,
        inputMode: "numeric",
        onChange: e => {
          input.onChange(e);
          handleAccountChange();
        },
        type: "text"
      })),
      validators: [required]
    }), /*#__PURE__*/_jsx(FinalFormField, {
      fieldProps: {
        name: 'assignees'
      },
      formControlProps: {
        marginBlockStart: '700',
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.assignAssignee"
        })
      },
      render: input => /*#__PURE__*/_jsx(AssigneeSelector, {
        accountId: accountId,
        input: input,
        isEditing: isEditing,
        selectedUsers: selectedUsers
      }),
      validators: [required]
    })]
  });
};
const StandardPortalUserAssign = ({
  isMultiUserAccount,
  isEditing,
  accountId,
  accounts,
  selectedUsers
}) => {
  const form = useForm();
  const handleAccountChange = () => {
    // Reset assignees when portal selection changes
    form.change('assignees', []);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FinalFormField, {
      fieldProps: {
        name: 'account'
      },
      formControlProps: {
        marginBlockStart: '700',
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.assignAccount"
        })
      },
      hidden: !isMultiUserAccount,
      render: input => /*#__PURE__*/_jsx(Select, Object.assign({}, input, {
        disabled: accounts.length === 1 || isEditing,
        onChange: e => {
          input.onChange(e);
          handleAccountChange();
        },
        options: accounts.map(account => ({
          value: account.id,
          text: I18n.text('learningCenter.playlists.assignAccountNameAndId', {
            accountName: I18n.SafeString(account.accountName),
            accountId: account.id.toString()
          })
        }))
      })),
      validators: [required]
    }), /*#__PURE__*/_jsx(FinalFormField, {
      fieldProps: {
        name: 'assignees'
      },
      formControlProps: {
        marginBlockStart: '700',
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.assignAssignee"
        })
      },
      render: input => /*#__PURE__*/_jsx(AssigneeSelector, {
        accountId: accountId,
        input: input,
        isEditing: isEditing,
        selectedUsers: selectedUsers
      }),
      validators: [required]
    })]
  });
};
const PlaylistAssignForm = ({
  accounts,
  hasError,
  dueDate,
  handleSubmitAsync,
  selectedUsers,
  isEditing,
  playlistAssignments,
  portalId,
  onClose,
  loadedNavMarker
}) => {
  const assignmentIdNotFound = isEditing && playlistAssignments && !playlistAssignments.length;
  if (assignmentIdNotFound) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [loadedNavMarker, /*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsx(Alert, {
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.assignmentNotFound"
          }),
          type: "danger"
        })
      }), /*#__PURE__*/_jsx(DialogFooter, {
        children: /*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.common.cancel"
          })
        })
      })]
    });
  }
  const isMultiUserAccount = (accounts || []).length > 1;
  return /*#__PURE__*/_jsx(Form, {
    initialValues: isEditing && playlistAssignments ? {
      assignees: playlistAssignments.map(pa => pa.assignee.userId),
      dueDate: dueDate ? fromDateToUiDateInputFormat(new Date(dueDate)) : null,
      accountsRadio: 'myAccounts',
      account: portalId,
      assignmentType: 'teamMembers'
    } : {
      dueDate: null,
      account: portalId || accounts.length && accounts[0].id || null,
      accountsRadio: 'myAccounts',
      assignmentType: 'teamMembers'
    },
    keepDirtyOnReinitialize: true,
    onSubmit: handleSubmitAsync,
    render: ({
      handleSubmit,
      values: {
        account: accountId,
        accountsRadio
      }
    }) => /*#__PURE__*/_jsxs(_Fragment, {
      children: [loadedNavMarker, /*#__PURE__*/_jsxs(FoundationsForm, {
        onSubmit: e => void handleSubmit(e),
        children: [/*#__PURE__*/_jsxs(DialogBody, {
          paddingBlockStart: "500",
          paddingInlineEnd: "900",
          paddingInlineStart: "800",
          children: [hasError && /*#__PURE__*/_jsx(ServerError, {}), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: accountsRadio === 'allAccounts' ? 'learningCenter.playlists.assignIntroductionPortalSearch' : isMultiUserAccount ? 'learningCenter.playlists.assignIntroductionMultiAccount' : 'learningCenter.playlists.assignIntroductionSingleAccount'
            })
          }), /*#__PURE__*/_jsx(HasScope, {
            fallback: /*#__PURE__*/_jsx(StandardPortalUserAssign, {
              accountId: accountId,
              accounts: accounts,
              isEditing: isEditing,
              isMultiUserAccount: isMultiUserAccount,
              selectedUsers: selectedUsers
            }),
            override: isEditing,
            scope: "academy-playlist-global-assignment",
            children: /*#__PURE__*/_jsx(AccountsTabs, {
              allAccounts: /*#__PURE__*/_jsx(HubSpotterPortalUserAssign, {
                accountId: accountId,
                accounts: accounts,
                isEditing: isEditing,
                isMultiUserAccount: isMultiUserAccount,
                selectedUsers: selectedUsers
              }),
              myAccounts: /*#__PURE__*/_jsx(StandardPortalUserAssign, {
                accountId: accountId,
                accounts: accounts,
                isEditing: isEditing,
                isMultiUserAccount: isMultiUserAccount,
                selectedUsers: selectedUsers
              })
            })
          }), /*#__PURE__*/_jsx(FinalFormField, {
            fieldProps: {
              name: 'dueDate',
              allowNull: true
            },
            formControlProps: {
              marginBlockStart: '700',
              label: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.common.dueDate"
              })
            },
            render: input => /*#__PURE__*/_jsx(DateInput, Object.assign({}, input, {
              min: fromDateToUiDateInputFormat(new Date()),
              tz: "utc"
            }))
          }), /*#__PURE__*/_jsx(Text, {
            as: "small",
            use: "help",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.playlists.assignDueDateHelpText"
            })
          })]
        }), /*#__PURE__*/_jsxs(DialogFooter, {
          children: [/*#__PURE__*/_jsx(Button, {
            type: "submit",
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.common.assign"
            })
          }), /*#__PURE__*/_jsx(Button, {
            onClick: onClose,
            use: "secondary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.common.cancel"
            })
          })]
        })]
      })]
    })
  });
};
const PlaylistAssignPanelInternal = ({
  playlistId,
  portalId,
  assignmentIds,
  onClose,
  onSuccess,
  loadedNavMarker
}) => {
  var _usersForAccount$user;
  const targetPortalId = portalId || PortalIdParser.getPortalIdFromPath();
  const {
    playlist
  } = usePlaylist(playlistId);
  const isEditing = assignmentIds && !!assignmentIds.length;
  const {
    accounts
  } = useAccounts();
  const {
    playlistAssignments
  } = usePlaylistAssignments({
    assignmentIds,
    skip: !isEditing
  });
  const selectedUserIds = useMemo(() => {
    if (!playlistAssignments) {
      return [];
    }
    return playlistAssignments.map(assignment => assignment.assignee.userId);
  }, [playlistAssignments]);
  const {
    usersForAccount
  } = useUsersForAccount({
    accountId: targetPortalId,
    userIds: selectedUserIds,
    skip: !isEditing || !selectedUserIds.length || !targetPortalId
  });
  const {
    createPlaylistAssignment,
    createPlaylistAssignmentError
  } = useCreatePlaylistAssignment();
  const {
    updatePlaylistAssignments,
    updatePlaylistAssignmentsError
  } = useUpdatePlaylistAssignments();
  const handleSubmitAsync = useCallback(async formData => {
    const {
      dueDate,
      account,
      assignees,
      assignmentType
    } = formData;
    if (!assignees) return;
    const dueDateUnixTs = dueDate ? fromUiDateInputFormatToUnixTs(dueDate) : undefined;
    if (!isEditing) {
      assignees.forEach(assignee => {
        UsageTracker.track('playlistInteraction', {
          action: 'playlist-assigned',
          playlistId,
          portalId: targetPortalId,
          hubspotterId: assignee,
          bulk: assignees.length > 1,
          date: dueDateUnixTs
        });
      });
    }
    const response = isEditing ? await updatePlaylistAssignments({
      assignmentIds,
      dueDate: dueDateUnixTs
    }) : await createPlaylistAssignment(Object.assign({
      playlistId,
      targetPortalId: account,
      dueDate: dueDateUnixTs
    }, assignmentType === 'teamMembers' ? {
      assigneeUserIds: assignees.map(Number)
    } : {
      teamIds: assignees.map(Number)
    })).then(createdAssignments => {
      if (createdAssignments) {
        FloatingAlertStore.addAlert({
          message: /*#__PURE__*/_jsx(PlaylistAssignedNotification, {
            assigneeCount: assignees.length,
            assignmentType: assignmentType,
            playlistId: playlistId
          }),
          type: 'success'
        });
      }
      return createdAssignments;
    }).catch();

    /**
     * If we receive a response, it means the request was successful.
     */
    if (response) {
      onSuccess === null || onSuccess === void 0 || onSuccess();
    }
  }, [assignmentIds, createPlaylistAssignment, isEditing, onSuccess, playlistId, targetPortalId, updatePlaylistAssignments]);
  const dueDates = playlistAssignments === null || playlistAssignments === void 0 ? void 0 : playlistAssignments.map(({
    dueDate
  }) => dueDate);
  const maybeCommonDueDate = dueDates && new Set(dueDates).size === 1 ? dueDates[0] : null;
  return /*#__PURE__*/_jsxs(ModalPanel, {
    width: 512,
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        justify: "between",
        children: [playlist && /*#__PURE__*/_jsx(H2, {
          marginBlockEnd: "0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.assignPlaylistName",
            options: {
              playlistName: playlist.name
            }
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onClose
        })]
      })
    }), playlist && accounts && /*#__PURE__*/_jsx(PlaylistAssignForm, {
      accounts: accounts,
      dueDate: maybeCommonDueDate,
      handleSubmitAsync: handleSubmitAsync,
      hasError: !!(createPlaylistAssignmentError || updatePlaylistAssignmentsError),
      isEditing: isEditing,
      loadedNavMarker: loadedNavMarker,
      onClose: onClose,
      playlistAssignments: playlistAssignments,
      portalId: targetPortalId,
      selectedUsers: (_usersForAccount$user = usersForAccount === null || usersForAccount === void 0 ? void 0 : usersForAccount.users) !== null && _usersForAccount$user !== void 0 ? _usersForAccount$user : []
    })]
  });
};
export const PlaylistAssignPanel = props => {
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(PlaylistAssignPanelInternal, Object.assign({}, props))
  });
};